import { useMutation, useQueryClient } from 'react-query';
import { AxiosError } from 'axios';
import api from 'services';
import { ApiError } from 'services/api.errors';
import {
  ImportContributionsPayload,
  ImportContributionsResponse,
} from 'services/requests';
import { MutationKeys } from 'constants/mutationKeys';
import { QueryKeys } from 'constants/queryKeys';
import { showInfoToast } from 'components/Toast';

export const useImportContributions = () => {
  const queryClient = useQueryClient();

  const mutate = async ({ file }: ImportContributionsPayload) => {
    const blob = new Blob([file], {
      type: file.type,
    });
    const formData = new FormData();
    formData.append('file', blob, file.name);

    const { data } = await api.importContributions(formData);
    return data;
  };

  const mutationKey = MutationKeys.importContributions;

  return useMutation<
    ImportContributionsResponse,
    AxiosError<ApiError>,
    ImportContributionsPayload
  >(mutationKey, mutate, {
    onSuccess: (data) => {
      if (data?.successResultDescription) showInfoToast(data.successResultDescription);
      queryClient.invalidateQueries(QueryKeys.contributionsList);
    },
  });
};
